import { FileParameter } from '../../services/ppv.api'

export enum CsvFileType {
   HospitalPricing = 'HospitalPricing',
   BatchUpdates = 'BatchUpdates',
   Rules = 'Rules',
   RuleSets = 'RuleSets',
}

export class ValidateCsvRequest {
   private _fileParameter: FileParameter
   expectedHeaders: string[]
   data: File
   fileName: string
   fileType: CsvFileType

   constructor(data: File, fileName: string, expectedHeaders: string[] = [], fileType: CsvFileType) {
      this._fileParameter = { data: data, fileName: fileName }
      this.data = data
      this.fileName = fileName
      this.expectedHeaders = expectedHeaders
      this.fileType = fileType
   }

   public get fileParameter(): FileParameter {
      return this._fileParameter
   }
}

export class UploadCsvEvent {
   fileParameters: FileParameter[]
   isSubmitting: boolean
   fileType: CsvFileType

   constructor(fileParameters: FileParameter[], isSubmitting: boolean, fileType: CsvFileType) {
      this.fileParameters = fileParameters
      this.isSubmitting = isSubmitting
      this.fileType = fileType
   }
}
